export enum ChipType {
    PITCHING = 'pitching',
    BRAND_EXPERIENCE = 'brandExperience',
    MARKETING = 'marketing',
    SALES = 'sales',
    HYPE_AND_PUBLICITY = 'hypeAndPublicity',
    SCALABILITY = 'scalability',
    SOFT_SKILLS = 'softSkills',
}

export const CHIP_CONFIG = {
    [ChipType.PITCHING]: {
        color: '#BBE7D3',
        title: 'pitching',
    },
    [ChipType.BRAND_EXPERIENCE]: {
        color: '#F47A53',
        title: 'brand experience',
    },
    [ChipType.MARKETING]: {
        color: '#D2CAFF',
        title: 'marketing',
    },
    [ChipType.SALES]: {
        color: '#97DFE3',
        title: 'sales',
    },
    [ChipType.HYPE_AND_PUBLICITY]: {
        color: '#EFFF9F',
        title: 'hype & publicity',
    },
    [ChipType.SCALABILITY]: {
        color: '#F47A53',
        title: 'scalability',
    },
    [ChipType.SOFT_SKILLS]: {
        color: '#D2CAFF',
        title: 'soft skills',
    },
} as const satisfies Record<ChipType, {color: string; title: string}>;

export interface ChipsProps {
    type: ChipType;
    variant?: 'default' | 'inline';
}

export const isValidChipType = (value: unknown): value is ChipType => {
    return typeof value === 'string' && Object.values(ChipType).includes(value as ChipType);
};
